import Collapsible from 'react-collapsible';
import OpportunityTrigger from './opportunity_trigger';
import ReactTooltip from 'react-tooltip';
import VisibilityDecider from './visibilityDecider';
import {getOptions,getMessage} from './getOptions';
import NoIssuesFound from './noIssuesFound';

function CssOldPropertyPrefixes(props){
   
   let items = props.report.offendersObj.list
   let options = getOptions(props,'ylb')
   let title = props.report.policy.label
   let msg = getMessage(options)
    msg = props.report.value

   let visibilityDecider = VisibilityDecider(props.config,options.is_critical,options.is_moderate,options.is_low,options.is_passed)

    return(

            <Collapsible lazyRender className={visibilityDecider} contentOuterClassName="panel" contentContainerTagName="div" triggerClassName="accordion" triggerOpenedClassName="accordion open" triggerTagName="button" trigger={["", <OpportunityTrigger classNameIndicators={options.classNameIndicators} msg={msg} is_critical={options.is_critical} is_low={options.is_low} is_moderate={options.is_moderate} is_passed={options.is_passed} arrowDirectionClass="fa fa-angle-down" title={title}/>]} triggerWhenOpen={["", <OpportunityTrigger classNameIndicators={options.classNameIndicators} msg={msg} is_critical={options.is_critical} is_low={options.is_low} is_moderate={options.is_moderate} is_passed={options.is_passed} arrowDirectionClass="fa fa-angle-up" title={title}/>]}>
                
            <p>Very easy to fix: remove all empty rules.</p>

            { Object.keys(items).length > 0 &&
            <table className="table table-striped table-responsive">
                <thead>
                <tr>
                    <th scope="col">Message</th>
                    <th scope="col">Property</th>                  
                </tr>
                </thead>
                <tbody>

            {Object.keys(items).map((key, index) => {
              return (<>
                        <tr className="parent-item" key={index}>
                          <td>{items[index]['message']}</td>
                          <td>{items[index]['property']}</td>
                        </tr>
                        {Object.keys(items[index]['rules']).map((k, j) => {
                            return (
                                <>
                                <tr className="sub-item" key={Math.random().toString(36).slice(2, 7)}>
                                <td>
                                    { items[index]['rules'][j]['file'] === '[inline CSS]' ? <span>{items[index]['rules'][j]['file']}</span> : <a data-tip={items[index]['rules'][j]['file']} target="_blank" href={items[index]['rules'][j]['file']}>{items[index]['rules'][j]['file']}</a>
                                    }
                                </td>
                                <td><span><b>Rule:</b> {items[index]['rules'][j]['rule']},<b>Value:</b> {items[index]['rules'][j]['value']},<b>Column:</b> {items[index]['rules'][j]['column']}, <b>Line:</b> {items[index]['rules'][j]['line']}</span></td>
                                </tr>
                                </>
                            );
                        })}
                    </>
              );
            })} 
                </tbody>
          </table>
          }
          { Object.keys(items).length === 0 &&
              <NoIssuesFound/>
          }           
            <ReactTooltip place="right" multiline={true} clickable={true} delayHide={1000} />
          </Collapsible>
          
    )
}

export default CssOldPropertyPrefixes